import { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import UserAvatar from '../../userAvatar';
import ActionButton from '../../actionButton';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  userAvatar: {
    width: 'calc(100% - 24px)',
  },
  avatarLabel: {
    color: primary.bluish1,
    fontFamily: 'ProximaNova-Bold',
    fontSize: 14,
    lineHeight: '18px',
    marginLeft: 0,
    paddingRight: spacing(1.5),
    width: '100%',
    userSelect: 'none',
  },
  closeIconButton: {
    height: 24,
    width: 24,
  },
  closeIcon: {
    height: 16,
    width: 16,
    '& path': {
      fill: primary.bluish1,
    },
  },
}));

const VirtualUser = ({ user, onRemove }) => {
  const classes = useStyles();

  const handleRemove = useCallback(() => onRemove(user), [user, onRemove]);

  return (
    <div className={classes.root}>
      <UserAvatar
        className={classes.userAvatar}
        labelClass={classes.avatarLabel}
        user={user}
        caption
        small
      />
      <ActionButton
        className={classes.closeIconButton}
        iconClass={classes.closeIcon}
        type={ACTION_BUTTON_TYPES.CLOSE}
        onClickHandler={handleRemove}
      />
    </div>
  );
};

VirtualUser.propTypes = {
  user: PropTypes.object.isRequired,
};

export default memo(VirtualUser);
